import cx from 'classnames';

import { Heading } from './Heading';
import styles from './Heading.css';

const HeadingPlugin = ({
  className,
  level,
  HEADING_TAG,
  ...attributes
} = {}) => ({
  renderElement: Heading({
    className: cx(styles.heading, styles[`heading${level}`], className),
    level,
    HEADING_TAG,
    ...attributes,
  }),
});

export { HeadingPlugin };
